import React, { useEffect, useState, useRef, useCallback } from "react";
import platform from "Pub/js/platform";
import { formatWatermarkPreviewConfig } from '../WatermarkSetting/common';
import { getWaterMarkObject } from '../../CompanyStyleSetting/common';
import { getMulti } from "Pub/js/getMulti";

const { NCWatermark } = platform.base;
class Watermark extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            watermarkPreviewConfig: null,
            watermarkConfig: null,
            json: null
        };
    }

    render() {
        const { watermarkConfig } = this.state;
        const { isPreview, watermarkSetting = {}, multiLangOptions, enable = true, children, ...otherProps } = this.props;
        const Wrapper = isPreview === true && !watermarkConfig ? NoWaterMark : NCWatermark ;
        
        
        return (
            <Wrapper
                // ref={el => watermarkRef.current = el}
                zIndex={999} // 默认层级高一点
                {...otherProps}
                {...watermarkConfig}
            >
                {children}
            </Wrapper>
        );
    }

    componentDidMount() {
        getMulti({
            moduleId: 'WatermarkSetting',
            domainName: 'workbench',
            callback: json => {
                // console.log('watermark2', json);
                this.setState({ json }, () => {
                    this.delayGetWatermarkConfig(this.props);
                });
            },
        });
        document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this));
    }

    delayGetWatermarkConfig(props) {
        // 延迟，不然会偶发水印渲染不上，原因未知
        setTimeout(() => {
            this.getWatermarkConfig(props);
        }, 0);
    }

    shouldComponentUpdate(nextProps) {
        if ((nextProps.watermarkSetting !== this.props.watermarkSetting) || (nextProps.enable !== this.props.enable)) {
            this.getWatermarkConfig(nextProps);         
        }
        return true;
    }

    getWatermarkConfig(props) {
        const { enable = true, watermarkSetting, multiLangOptions } = props;
        const { json } = this.state;
        const { usewatermark, marktpl, markimg } = watermarkSetting;
        // console.log('watermark4', watermarkSetting);
        if (enable && json && usewatermark && (marktpl.length > 0 || markimg)) {
            formatWatermarkPreviewConfig(watermarkSetting, multiLangOptions, json).then(previewData => {
                // console.log('watermark3', previewData);
                this.setState({ watermarkConfig: previewData });
            });
        } else {
            this.setState({ watermarkConfig: null });
        }
    }

    onVisibilityChange(e) {
        if (document.visibilityState === 'visible') {
            this.delayGetWatermarkConfig(this.props);
        }
    }
}

function NoWaterMark(props) {
    const { children, className = '', style = {} } = props;
    return <div className={className} style={style}>{children}</div>
}

// 把后台返回的水印数据转成水印需要的数据结构
Watermark.transWatermarkSettings = getWaterMarkObject;

export default Watermark;
